// extracted by mini-css-extract-plugin
module.exports = {"BREAK_WIDTH_S":"1151px","BREAK_WIDTH_XS":"767px","BREAK_HEIGHT_XXSM":"560px","BREAK_WIDTH_NAV":"620px","BREAK_WIDTH_NAV_M":"1150px","BREAK_RIGHT_RAIL_HIDDEN":"684px"};